import cn from 'classnames/bind'

import PlainDateMonthSwitcher from 'app/common/ui-next/plain-date-month-picker'
import * as dateTypes from 'app/common/constants/dateTypes'
import useFromTo from 'app/common/hooks/useFromTo'
import Sticky from 'app/common/templates-next/sticky'
import { PageTemplateContent, Header2 } from 'app/common/templates-next/page-template'
import PlainDateSwitcher from 'app/common/ui-next/plain-date-switcher'
import SimpleDate from 'app/common/classes/simple-date'

import { PurchasesApi, statuses } from '../PurchasesApi' // eslint-disable-line no-unused-vars
import ScheduleTable from './ScheduleTable'

import styles from './CafeteriaSchedule.module.scss';

const cx = cn.bind(styles)

type Props = {
  date: SimpleDate
  dateType: 'day' | 'month'
  header?: string
  person: {
    id: number
    name: {
      first: string
      last: string
      middle: string
      gender: 'male' | 'female' | 'androgynous'
    }
    timezone: string
  }
  onChangeDate: (date: string, dateFormat: string, daily?: boolean) => void
}

/**
 *   Компонент столовой: График питания
 */

const CafeteriaSchedule = ({
  date,
  dateType: dt,
  header = 'График питания',
  person: { id: personId, name: personName, timezone },
  onChangeDate,
}: Props) => {
  const dateString = date.getStringFormatted(dt === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM')
  const dateType = dt === 'day' ? dateTypes.DAYS : dateTypes.MONTHS // length(split('-', date)) // 2 - мясяцы, 3 - дни

  const [from, to] = useFromTo({ date: dateString, dateType })

  return (
    <PurchasesApi personId={personId} from={from} to={to} status={statuses.SPENT} autoRequest>
      <Sticky>
        {(ref, sticky) => (
          <PageTemplateContent reference={ref} className={cx({ sticky })} flex>
            <Header2 skipMargin>{header}</Header2>
            <PlainDateSwitcher
              date={dateString}
              dateFormat={dateType === dateTypes.MONTHS ? 'YYYY-MM' : 'YYYY-MM-DD'}
              displayDateFormat={dateType === dateTypes.MONTHS ? 'MMMM' : undefined}
              stepType={dt}
              onDateChange={onChangeDate}
            >
              <PlainDateMonthSwitcher
                date={dateString}
                dateFormat={dateType === dateTypes.MONTHS ? 'YYYY-MM' : 'YYYY-MM-DD'}
                onChangeDate={onChangeDate}
                hideDateMonthSwitcher
                monthsAmount={24}
              />
            </PlainDateSwitcher>
          </PageTemplateContent>
        )}
      </Sticky>
      <ScheduleTable timezone={timezone} date={dateString} />
    </PurchasesApi>
  )
}

export default CafeteriaSchedule
